module.exports = __webpack_public_path__ + "img/pc_banner_cookie.962715ca.jpeg";